/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */

import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/management/events`;

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  let cmt = false;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      cmt = true;
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  if (cmt) {
    commit('updateError', err);
  } else {
    throw err;
  }
}
const state = {
  events: null,
  pending: false,
  updatePending: false,
  error: null,
  updateError: null,
};

const getters = {
  loaded: (state) => !state.pending && state.events != null,
  events: (state, getters) => (getters.loaded ? state.events : []),
  updatePending: (state) => (state.updatePending),
  pending: (state) => (state.pending),
  updateError: (state) => (state.updateError),
};

const mutations = {
  clearErrors(state) {
    state.error = null;
    state.updateError = null;
  },
  beforeRequest(state) {
    state.error = null;
    state.pending = true;
  },
  update(state, error = null) {
    state.updatePending = false;
    state.updateError = error;
  },
  beforeUpdate(state) {
    state.updateError = null;
    state.updatePending = true;
  },
  afterUpdate(state) {
    state.updatePending = false;
  },
  events(state, events) {
    state.pending = false;
    state.events = events;
  },
  updateError(state, error) {
    state.updateError = error;
  },
  deleted(state, id) {
    const idx = state.events?.content.findIndex((message) => Number(message.id) === Number(id));
    if (idx !== -1) {
      state.events.content.splice(idx, 1);
    }
    state.updatePending = false;
  },
};

const actions = {
  async getEvents({ commit }, payload) {
    try {
      commit('beforeRequest');
      const { data } = await ApiService.post(`${endpoint}/list`, payload);
      commit('events', data);
      return data;
    } catch (error) {
      commit('error', error);
      return [];
    }
  },
  async updateEvent({ commit }, payload) {
    commit('beforeUpdate');
    try {
      await ApiService.put(`${endpoint}/${payload.id}`, payload);
      commit('afterUpdate');
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
  async saveEvent({ commit }, payload) {
    commit('beforeUpdate');
    try {
      await ApiService.post(`${endpoint}`, payload);
      commit('afterUpdate');
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
  async deleteEvent({ commit }, id) {
    commit('beforeUpdate');
    try {
      await ApiService.delete(`${endpoint}/${id}`);
      commit('deleted', id);
      return true;
    } catch (error) {
      commit('afterUpdate');
      handleApiError(commit, error);
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
